@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.config

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.web.models.RoutingProvider
import com.narbase.letsgo.web.models.RoutingType

data class CallCenterConfigDto (
    val phoneNumber: String,
    val locationRecencyInMins: Int,
    val sipExtension: SipExtensionDto,
    val routing : RoutingSettingsDto,
    val voipSettings: VoipSettingsDto
)


data class SipExtensionDto(
    val extension: String,
    val domain: String,
    val specialOfferExtension: String?
)
class VoipSettingsDto(
    val tempFailTimeoutInMin: Int
)


class RoutingSettingsDto(
    @Suppress("NON_EXPORTABLE_TYPE") val provider: DtoName<RoutingProvider>,
    @Suppress("NON_EXPORTABLE_TYPE") val type: DtoName<RoutingType>
)